<div class="orders" class="page-layout carded fullwidth" style="width: 100%;">
    <div class="top-bg primary"></div>

    <div class="center">
        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutAlign.gt-xs="space-between center">
            <!-- APP TITLE -->
            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'DEVICE_INFORMATION' | translate}}</span>
            </div>
            <!-- / APP TITLE -->
            <span class="mat-display my-0 my-sm-24 " [@animate]="{value:'*',params:{x:'50px'}}">
                <b>{{'DISPLAYED_DEVICE'|translate}} :</b> {{deviceId!=null?deviceId:"---"}}  
            </span>
        </div>
        <!-- / HEADER -->
        <div id="dashboard-project" class="page-layout carded fullwidth inner-scroll" fxLayout="row">
            <!-- CENTER -->
            <div class="center" fusePerfectScrollbar>
                <!-- CONTENT CARD -->
                <mat-card class="my-20" fxLayout="column">
                    <div class="py-20" fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="space-evenly center">
                        <div fxFlex="20" fxFlex.gt-xs="40" fxFlex.gt-md="50" fxLayout="column" fxLayoutAlign="flex-start center">
                            <div class="h3 secondary-text custom-text">{{'GPS_LOCATION'|translate}}</div>
                            <span class="custom-text">{{(requestList?.gpS_Enlem==null?'---':requestList?.gpS_Enlem)+"N,"+(requestList?.gpS_Boylam==null?'---':requestList?.gpS_Boylam)+"E"}}
                            </span>
                        </div>
                        <div fxFlex="80" fxFlex.gt-xs="60" fxFlex.gt-md="50" fxLayout="column" fxLayout.gt-xs="row" fxLayoutGap="10px">
                            <div fxLayout="column">
                                <span class="h3 secondary-text custom-text">{{'INSUFFICIENT_BATTERY_COUNT'|translate}}</span>
                                <span class="custom-text">{{(requestList?.yetersizBataryaUyanamamaCount==null?'---':requestList?.yetersizBataryaUyanamamaCount)}}</span>
                            </div>
                            <div fxLayout="column">
                                <span class="h3 secondary-text custom-text">{{'GSM_SIGNAL_WARNING'|translate}}</span>
                                <span class="custom-text">{{(requestList?.gsM_SinyaliYakalayamamaCount==null?'---':requestList?.gsM_SinyaliYakalayamamaCount)}}</span>
                            </div>
                            <div fxLayout="column">
                                <span class="h3 secondary-text custom-text">{{'UNABLE_FIX_GPS'|translate}}</span>
                                <span class="custom-text">{{(requestList?.gpS_VerisiFixleyememeCount==null?'---':requestList?.gpS_VerisiFixleyememeCount)}}</span>
                            </div>
                            <div fxLayout="column">
                                <span class="h3 secondary-text custom-text">{{'SERVER_COMMUNICATION_COUNT'|translate}}</span>
                                <span class="custom-text">{{(requestList?.sunucuHaberlesememeCount==null?'---':requestList?.sunucuHaberlesememeCount)}}</span>
                            </div>
                            <div fxLayout="column">
                                <span class="h3 secondary-text custom-text">{{'MAX_AWAKE_TIME_EXCEEDED'|translate}}</span>
                                <span class="custom-text">{{(requestList?.maxUyaniklikSuresiAsmaCount==null?'---':requestList?.maxUyaniklikSuresiAsmaCount)}}</span>
                            </div>
                        </div>
                    </div>
                </mat-card>
                <div class="content-card my-20">
                    <!-- CONTENT -->
                    <div class="content">

                        <mat-tab-group fxLayout="column" fxFlex="100">

                            <mat-tab label="{{'DEVICE_INFORMATION'|translate}}">
                                <div class="w-100-p p-24" fxLayout="row wrap" fxLayoutAlign="end center" fxLayoutGap="10px grid">
                                    <mat-form-field color="accent">
                                        <mat-label>{{'START_DATE'|translate}}</mat-label>
                                        <input matInput [(ngModel)]="startDate" [max]="endDate" (dateChange)="getByDateBetweenRequests()"  [matDatepicker]="pickerStart">
                                        <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerStart></mat-datepicker>
                                    </mat-form-field>
                                      
                                    <mat-form-field color="accent">
                                        <mat-label>{{'END_DATE'|translate}}</mat-label>
                                        <input matInput  [min]="startDate" (dateChange)="getByDateBetweenRequests()"  [(ngModel)]="endDate" [matDatepicker]="pickerEnd">
                                        <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
                                        <mat-datepicker #pickerEnd color="primary"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="w-100-p p-24">
                                    <div class="chart-card">
                                        <div id="msfChart">
                                            <apx-chart
                                              [series]="msfChartOptions.series"
                                              [chart]="msfChartOptions.chart"
                                              [xaxis]="msfChartOptions.xaxis"
                                              [yaxis]="msfChartOptions.yaxis"
                                              [labels]="msfChartOptions.labels"
                                              [tooltip]="msfChartOptions.tooltip"
                                              [theme]="msfChartOptions.theme"
                                              [dataLabels]="msfChartOptions.dataLabels"
                                              [grid]="msfChartOptions.grid"
                                              [stroke]="msfChartOptions.stroke"
                                              [title]="msfChartOptions.title"
                                            ></apx-chart>
                                          </div>
                                    </div>
                                </div>
                                <div class="my-20 mx-20" fxLayout="column" fxLayout.gt-sm="row wrap" fxFlex="100" fxLayoutGap="20px grid" fxLayoutAlign="space-evenly">
                                    <div fxFlex="100" fxFlex.gt-sm="50">
                                        <div class="chart-card">
                                            <div id="heatChart">
                                                <apx-chart
                                                [series]="heatChartOptions.series"
                                                [chart]="heatChartOptions.chart"
                                                [xaxis]="heatChartOptions.xaxis"
                                                [yaxis]="heatChartOptions.yaxis"
                                                [labels]="heatChartOptions.labels"
                                                [tooltip]="heatChartOptions.tooltip"
                                                [theme]="heatChartOptions.theme"
                                                [dataLabels]="heatChartOptions.dataLabels"
                                                [grid]="heatChartOptions.grid"
                                                [stroke]="heatChartOptions.stroke"
                                                [title]="heatChartOptions.title"
                                                ></apx-chart>
                                            </div>
                                        </div>
                                    </div>
                                    <div fxFlex="100" fxFlex.gt-sm="50">
                                        <div class="chart-card">
                                            <div id="batChart">
                                                <apx-chart
                                                  [series]="batChartOptions.series"
                                                  [chart]="batChartOptions.chart"
                                                  [xaxis]="batChartOptions.xaxis"
                                                  [yaxis]="batChartOptions.yaxis"
                                                  [labels]="batChartOptions.labels"
                                                  [tooltip]="batChartOptions.tooltip"
                                                  [theme]="batChartOptions.theme"
                                                  [dataLabels]="batChartOptions.dataLabels"
                                                  [grid]="batChartOptions.grid"
                                                  [stroke]="batChartOptions.stroke"
                                                  [title]="batChartOptions.title"
                                                ></apx-chart>
                                              </div>
                                        </div>
                                    </div>
                                </div>
                            </mat-tab>

                            <!-- Tab 3 Device log-->
                            <mat-tab label="{{'DEVICE_LOGS'|translate}}">
                                <div class="content-card" style="min-width: 1500px;">
                                    <div class="orders-table p-24">
                                        <div class="w-100-p" style="padding-bottom: 5px; display: flex; justify-content: end;">
                                            <button mat-mini-fab (click)="onReportRateClick()">
                                                <mat-icon>cloud_download</mat-icon>
                                            </button>
                                        </div>
                                        <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table (matSortChange)="sortData($event)"
                                            [dataSource]="dataSource" matSort matSortActive="date" matSortDirection="desc">

                                            <!-- Firmware Column -->
                                            <ng-container matColumnDef="frm">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>Firmware
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.firmware!=null?device.firmware:"---"}}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- Enlem Column -->
                                            <ng-container matColumnDef="gpS_Enlem">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{'LATITUDE'|translate}}
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.gpS_Enlem!=null?device.gpS_Enlem:"---"}}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- Boylam Column -->
                                            <ng-container matColumnDef="gpS_Boylam">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'LONGITUDE'|translate}}
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.gpS_Boylam!=null ? device.gpS_Boylam:"---"}}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- GF Column -->
                                            <ng-container matColumnDef="gpS_Fix">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{'GPS_FIX'|translate}}
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.gpS_Fix!=null?device.gpS_Fix:"---"}}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- GS Column -->
                                            <ng-container matColumnDef="gpS_Uydu_Sayisi">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{'NUMBER_OF_GPS_SATELLITES'|translate}}
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.gpS_UyduSayisi!=null?device.gpS_UyduSayisi:"---" }}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- GR Column -->
                                            <ng-container matColumnDef="gpS_Dinleme_Sayisi">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{'NUMBER_OF_GPS_LISTENING'|translate}}
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.gpS_DinlemeSayisi!=null?device.gpS_DinlemeSayisi:"---"}}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- ALT Column -->
                                            <ng-container matColumnDef="gpS_Rakim">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{'GPS_ALTITUDE'|translate}}
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.gpS_Rakim!=null?device.gpS_Rakim:"---" }}
                                                </mat-cell>
                                            </ng-container>

                                            <!-- Solar V Column -->
                                            <ng-container matColumnDef="slr">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{'SOLAR_VOLTAGE'|translate}}
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.solarEnerjiVoltaj!=null?device.solarEnerjiVoltaj/100:"---"}}V
                                                </mat-cell>
                                            </ng-container>

                                            <!-- Battary Column -->
                                            <ng-container matColumnDef="bat">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{'BATTERY'|translate}}
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.batarya!=null?device.batarya/100:"---"}}V
                                                </mat-cell>
                                            </ng-container>

                                            <!-- CPU Column -->
                                            <ng-container matColumnDef="sck">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{'CPU_HEAT'|translate}}
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.cpuSicaklik!=null?device.cpuSicaklik/10:"---"}}°C
                                                </mat-cell>
                                            </ng-container>

                                            <!-- GSM Level Column -->
                                            <!-- <ng-container matColumnDef="gsq">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    GSM Level
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.gsM_Sinyal!=null?device.gsM_Sinyal:"---"}}
                                                </mat-cell>
                                            </ng-container> -->

                                
                                            <!-- <ng-container matColumnDef="ack">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>P
                                                    Time
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.acikKalmaSuresi!=null?device.acikKalmaSuresi:"---"}}
                                                </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="ags">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    GC Time
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.gsM_BaglantiSuresi!=null?device.gsM_BaglantiSuresi:"---"}}
                                                </mat-cell>
                                            </ng-container> -->

                                            <!-- Doluluk Column -->

                                            <ng-container matColumnDef="msf">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{'DISTANCE'|translate}}
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.mesafe!=null?device.mesafe:"---"}}mm
                                                </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="alarmType">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{'ALARM_TYPE'|translate}}
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{(device.alarmType | AlarmTypePipe)|translate}}
                                                </mat-cell>
                                            </ng-container>

                                           
                                            <!-- <ng-container matColumnDef="dbG0">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    B. Cou
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.yetersizBataryaUyanamamaCount!=null?device.yetersizBataryaUyanamamaCount:"---"}}
                                                </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="dbG1">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    GSM Cou
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.gsM_SinyaliYakalayamamaCount!=null?device.gsM_SinyaliYakalayamamaCount:"---"}}
                                                </mat-cell>
                                            </ng-container>

                                      
                                            <ng-container matColumnDef="dbG2">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    B. Cou
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.gpS_VerisiFixleyememeCount!=null?device.gpS_VerisiFixleyememeCount:"---"}}
                                                </mat-cell>
                                            </ng-container>


                                            
                                            <ng-container matColumnDef="dbG3">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    Req. Cou.
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.sunucuHaberlesememeCount!=null?device.sunucuHaberlesememeCount:"---"}}
                                                </mat-cell>
                                            </ng-container>

                                            <ng-container matColumnDef="dbG4">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    Per. Cou
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    {{device.maxUyaniklikSuresiAsmaCount!=null?device.maxUyaniklikSuresiAsmaCount:"---"}}
                                                </mat-cell>
                                            </ng-container> -->

                                            <ng-container matColumnDef="date">
                                                <mat-header-cell *matHeaderCellDef mat-sort-header>
                                                    {{'DATE'|translate}}
                                                </mat-header-cell>
                                                <mat-cell *matCellDef="let device">
                                                    <p style="overflow: hidden; white-space: normal;"
                                                        class="total-price text-truncate">
                                                        {{device?.sonBaglantiTarih!=null?(device?.sonBaglantiTarih  | date:"dd / MM / y HH:mm"):"---"}}
                                                    </p>
                                                </mat-cell>
                                            </ng-container>

                                            <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true">
                                            </mat-header-row>
                                            <mat-row *matRowDef="let device; columns: displayedColumns;" class="order"
                                                matRipple>
                                            </mat-row>
                                        </mat-table>
                                        
                                        <mat-paginator #paginator [length]="pageLenght" [pageSize]="10" (page)="pageEvent($event)"
                                        [pageSizeOptions]="[10, 50, 100]">
                                    </mat-paginator>
                                </div>
                                </div>
                            </mat-tab>
                        </mat-tab-group>

                    </div>
                    <!-- / CONTENT -->
                </div>
                <!-- / CONTENT CARD -->
            </div>
            <!-- / CENTER -->
        </div>
    </div>
</div>